import { CacheLocalStorage } from 'infra/cache/cache-local-storage'
import { SetLocalStorage } from 'infra/cache/get-local-storage copy'
import { RemoveLocalStorage } from 'infra/cache/remove-local-storage'
import { GetLocalStorage } from 'infra/cache/set-local-storage'

export const makeCacheLocalStorage = () =>
  new CacheLocalStorage(new GetLocalStorage(), new SetLocalStorage(), new RemoveLocalStorage())
